export default __webpack_public_path__ + "static/media/afternoon.a71ac7de.svg";